import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";

export const DATA_GRID_COLUMNS = [
  DATA_GRID_COLUMN_TYPES.SELECTION,
  DATA_GRID_COLUMN_TYPES.CODE,
  DATA_GRID_COLUMN_TYPES.TITLE,
  DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
  DATA_GRID_COLUMN_TYPES.GRADE_LEVELS,
  DATA_GRID_COLUMN_TYPES.GRADING_TYPE,
  DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS,
  DATA_GRID_COLUMN_TYPES.TAGS,
  DATA_GRID_COLUMN_TYPES.DESCRIPTION,
  DATA_GRID_COLUMN_TYPES.ID,
  DATA_GRID_COLUMN_TYPES.LIST_PARENT,
  DATA_GRID_COLUMN_TYPES.ARCHIVE,
];
